import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { AuthState, initialAuthState } from './auth.state';

export const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.loginInitiated, (state): AuthState => ({
    ...state,
    status: 'loading',
    error: null,
  })),
  on(
    AuthActions.loginSuccess,
    (_state, { token, expiresAt, userId, displayName, email }): AuthState => ({
      token,
      expiresAt,
      userId,
      displayName,
      email,
      status: 'authenticated',
      error: null,
    }),
  ),
  on(AuthActions.loginFailure, (state, { error }): AuthState => ({
    ...state,
    status: 'error',
    error,
  })),
  on(AuthActions.logout, AuthActions.sessionExpired, (): AuthState => ({ ...initialAuthState })),
  on(AuthActions.tokenRefreshed, (state, { token, expiresAt }): AuthState => ({
    ...state,
    token,
    expiresAt,
  })),
);
